import { render, staticRenderFns } from "./editable-info.vue?vue&type=template&id=39904a5c&scoped=true&"
import script from "./editable-info.vue?vue&type=script&lang=js&"
export * from "./editable-info.vue?vue&type=script&lang=js&"
import style0 from "./editable-info.vue?vue&type=style&index=0&id=39904a5c&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39904a5c",
  null
  
)

export default component.exports